import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'
import { message } from 'antd'

const service = new ApolloClientService()

export default class Event {
  getAllSurgeryTypes = () => {
    return new Promise((resolve, reject) => {
      service
        .getAllSurgeryTypes()
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
